"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineResponse20026ToJSON = exports.InlineResponse20026FromJSONTyped = exports.InlineResponse20026FromJSON = void 0;
function InlineResponse20026FromJSON(json) {
    return InlineResponse20026FromJSONTyped(json, false);
}
exports.InlineResponse20026FromJSON = InlineResponse20026FromJSON;
function InlineResponse20026FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nickname': json['nickname'],
    };
}
exports.InlineResponse20026FromJSONTyped = InlineResponse20026FromJSONTyped;
function InlineResponse20026ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'nickname': value.nickname,
    };
}
exports.InlineResponse20026ToJSON = InlineResponse20026ToJSON;
